import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ColumnSettings, safetySettingsInitialState } from './safety-settings-initial-state';

const safetySettingsSlice = createSlice({
    name: 'safetySettings',
    initialState: safetySettingsInitialState,
    reducers: {
        setBreachColumnVisibility: (state, action: PayloadAction<{ key: string; visible: boolean }>) => {
            const column = state.breachColumnSettings.find((c) => c.key === action.payload.key);
            if (column) {
                column.visible = action.payload.visible;
                return;
            }

            // a column added after these settings were saved is only in the defaults
            const added = safetySettingsInitialState.breachColumnSettings.find((c) => c.key === action.payload.key);
            if (added) {
                state.breachColumnSettings.push({ ...added, visible: action.payload.visible, order: state.breachColumnSettings.length });
            }
        },
        setBreachColumnOrder: (state, action: PayloadAction<ColumnSettings[]>) => {
            state.breachColumnSettings = action.payload;
        },
        resetBreachColumnSettings: (state) => {
            state.breachColumnSettings = safetySettingsInitialState.breachColumnSettings;
        },
        setHideSilentEquipment: (state, action: PayloadAction<boolean>) => {
            state.hideSilentEquipment = action.payload;
        },
    },
});

export const {
    setBreachColumnVisibility,
    setBreachColumnOrder,
    resetBreachColumnSettings,
    setHideSilentEquipment,
} = safetySettingsSlice.actions;

export default safetySettingsSlice.reducer;